import { namespace } from 'vuex-class';

export const networkSecurityAndInternet = namespace('tickets/networkSecurityAndInternet');
export const managementAndManagedServices = namespace('tickets/managementAndManagedServices');
export const linkManagement = namespace('tickets/linkManagement');
export const networkSecurityInternetIncident = namespace('tickets/networkSecurityInternetIncident');
export const processingAndManagedManagement = namespace('tickets/processingAndManagedManagement');
